/**
 * Constante CHIPS — sources de verite des filtres rapides de la liste dossiers.
 *
 * Extraite dans `lib/` pour etre testable en node:test (les .jsx ne sont pas
 * chargeables par node sans bundler). Le composant `FilterChips.jsx` re-exporte
 * pour la compat.
 *
 * P2-real (S2) : ajout du chip 'bloque' (l API renvoyait deja byStatus.bloque
 * mais sans chip on ne pouvait pas isoler).
 */

/**
 * @typedef {object} ChipDef
 * @property {string} key - identifiant unique
 * @property {string} label - libelle visible
 * @property {object} filter - objet de filtres a appliquer (passable a listDossiers)
 */

/** @type {ReadonlyArray<ChipDef>} */
export const CHIPS = Object.freeze([
  Object.freeze({ key: 'all', label: 'Tous', filter: Object.freeze({}) }),
  Object.freeze({ key: 'alerte', label: 'A relancer', filter: Object.freeze({ alerteOnly: true }) }),
  Object.freeze({ key: 'collecte', label: 'Collecte', filter: Object.freeze({ status: 'collecte' }) }),
  Object.freeze({ key: 'attente_signature', label: 'Signature', filter: Object.freeze({ status: 'attente_signature' }) }),
  Object.freeze({ key: 'transmis', label: 'Transmis', filter: Object.freeze({ status: 'transmis' }) }),
  Object.freeze({ key: 'logistique', label: 'Livraison', filter: Object.freeze({ status: 'logistique' }) }),
  Object.freeze({ key: 'cloture', label: 'Termines', filter: Object.freeze({ status: 'cloture' }) }),
  Object.freeze({ key: 'bloque', label: 'Bloque', filter: Object.freeze({ status: 'bloque' }) }),
]);
